<template>
  <div class="log-weather-box">
    <!-- 显示传感器图片 -->
    <template v-if="type != 'sensor'">
      <div class="log-wb-left" :class="type">
        <div class="log-wb-img-farth flex-center">
          <img :src="imgList[type]" />
        </div>
        <!-- 土壤传感器显示 imei -->
        <template v-if="type=='soil'">
          <div class="soil-mac ellipsis">
            <div class="ellipsis">
              <span>imei：</span>
              <span>{{macInfo.imei}}</span>
            </div>
            <div v-if='macInfo.marker' class="ellipsis">
              <span>备注名：</span>
              <span>{{macInfo.marker}}</span>
            </div>
          </div>
        </template>
      </div>
    </template>
    <!-- 传感器信息 -->
    <div class="log-wb-right">
      <!-- 不是土壤传感器显示 mac -->
      <template v-if="type!='soil'">
        <div class="normal-mac ellipsis">
          <div class="ellipsis">
            <span>Mac:</span>
            <span>{{macInfo.imei}}</span>
          </div>
          <div v-if='macInfo.marker' class="ellipsis">
            <span>备注名:</span>
            <span>{{macInfo.marker}}</span>
          </div>
        </div>
      </template>
      <!-- 传感器数据 -->
      <div class="right-bottom-x" :class="type">
        <!-- 土壤 -->
        <template v-if="type=='soil'">
          <div class="data-num-x">
            <div v-for="i in 4" :key='i' class="blockCard"></div>
          </div>
          <div class="real-x soil">
            <template v-for="(depth, index) in dataInfo">
              <div class="soil-info" :key="index">
                <div>
                  <span>深度</span>
                  <span class="f-w">{{depth.depth}}CM</span>
                </div>
                <div class="line"></div>
              </div>
              <template v-if="depth.dataList.length == 0">
                <div class="soil-no-data flex-center" :key="`${index}-empty`">
                  该深度暂无传感器
                </div>
              </template>
              <template v-else>
                <div class="data-num-x" :key="`${index}-data`">
                  <template v-for='(item, index) in depth.dataList'>
                    <sensorDataCard :info='item' :key="index" class='data-card'></sensorDataCard>
                  </template>
                </div>
              </template>
            </template>
            <template v-if='dataInfo.length == 0'>
              <div class="soil-no-data flex-center">
                该设备暂无传感器
              </div>
            </template>
          </div>
        </template>
        <!-- 虫情 -->
        <template v-if="type=='insert'">
          <div class="insert-info">
            <div class="insert-info-title f-w">设备状态：</div>
            <div class="insert-body">
              <template v-for="(row, index) in dataInfo['top'] || []">
                <div class="insert-row" :key="index">
                  <template v-for="(box, index) in row">
                    <div class="insert-box" :key="index">
                      <template v-for="(item, index) in box">
                        <div class="right-border" :key="index">
                          <img :src="item.img" alt="">
                          <span class="name">{{item.name}}</span>
                          <span class="value">{{item.data}}{{item.unit || null}}</span>
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
          <div class="data-num-x">
            <template v-for='(item, index) in dataInfo["bottom"] || []'>
              <sensorDataCard :info='item' :key="index" class='data-card'></sensorDataCard>
            </template>
            <template v-if='!!!dataInfo["bottom"]'>
              <template v-for='(item, index) in 4'>
                <div :key="index" class="blockCard"></div>
              </template>
            </template>
          </div>
        </template>
        <!-- 传感器 / 天气 -->
        <template v-if="type == 'sensor' || type == 'weater'">
          <template v-if='dataInfo.length <= 8 && (Object.prototype.toString.call(dataInfo[0]) != "[object Array]")'>
            <div class="data-num-x">
              <template v-for='(item, index) in dataInfo'>
                <sensorDataCard :info='item' :key="index" class='data-card'></sensorDataCard>
              </template>
            </div>
          </template>
          <template v-else>
            <Carousel>
              <template v-for="(page, index) in dataInfo">
                <div class="data-num-x" :key="index">
                  <template v-for='(item, index) in page'>
                    <sensorDataCard :info='item' :key="index" class='data-card'></sensorDataCard>
                  </template>
                  <template v-if='page.length < 8'>
                    <template v-for="(item, index) in 8 - page.length">
                      <div class="blockCard" :key="index + '-block'"></div>
                    </template>
                  </template>
                </div>
              </template>
            </Carousel>
          </template>
          <template v-if="dataInfo.length == 0">
            <div class="soil-no-data flex-center">
              该设备暂无传感器
            </div>
            <div class="data-num-x">
              <template v-for='(item, index) in 4'>
                <div class="blockCard" :key="index"></div>
              </template>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import sensorDataCard from "./sensorDataCard.vue";
import Carousel from "./Carousel.vue";

export default {
  props: ['type', 'dataInfo', 'macInfo'],
  components: {
    sensorDataCard,
    Carousel
  },
  data() {
    return {
      // type: 'weater', // weater insert soil sensor
      imgList: {
        insert: require('./../assets/log-device/insert.png'),
        weater: require('./../assets/log-device/weaterStation.png'),
        soil: require('./../assets/log-device/soil.png')
      }
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style scoped>
.soil.log-wb-left .log-wb-img-farth img {
  width: 3vw;
}

.insert-row:first-child>div:last-child>div:last-child::after {
  /* border-right:none ; */
  display: none;
}

.insert-row:last-child>div:first-child>div:last-child::after {
  /* border-right:none ; */
  display: initial;
}

.insert-row:last-child>div>div::after {
  /* border-right:none ; */
  display: none;
}

.real-data-box {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}

.carousel {
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 500ms ease 0s;
}

.carousel-box {
  position: relative;
  overflow: hidden;
}

.carousel>div {
  flex-shrink: 0;
}

.carousel {
  display: flex;
  white-space: nowrap;
}

.blockCard {
  width: 6.5vw;
  min-width: 100px;
  height: 1vw;
  display: inline-block;
}

.soil-data-card-list {
  max-height: 100%;
  overflow: auto;
}

.soil-data-card-list::-webkit-scrollbar {
  width: 5px;
  background: #084D67;
}

.soil-data-card-list::-webkit-scrollbar-thumb {
  background: #138AA3;
}

.soil-no-data {
  color: #007491;
  font-size: 0.8vw;
  margin: 0.5vw 0 1vw;
}

.line::before {
  content: " ";
  display: inline-block;
  width: 2px;
  height: 0.2rem;
  background: #01BAE1;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.line {
  position: relative;
  height: 2px;
  flex: 1;
  background: #01BAE1;
}

.soil-info>div>span:nth-child(2) {
  color: #fff;
  font-size: 0.28rem;
  margin: 0 0.8em;
}

.soil-info>div>span:nth-child(1) {
  color: #01BAE1;
}

.soil-info {
  font-size: 0.2rem;
  margin-top: 1em;
  display: flex;
  align-items: center;
}

.right-border::after {
  position: absolute;
  content: " ";
  width: 2px;
  height: 60%;
  background: #155C9A;
  right: 0;
  top: 20%;
  /* border-right: 1px solid #155C9A; */
}

.insert-box img {
  width: 1vw;
  height: auto;
  margin-right: 0.3em;
  align-self: center;
}

.insert-box>div>span:nth-last-child(2) {
  color: #4AB0DF;
  font-size: 0.8vw;
  letter-spacing: 0.1vw;
}

.insert-box>div>span:nth-last-child(1) {
  font-weight: bold;
  font-size: 0.8vw;
  margin-left: 0.1vw;
}

.insert-box>div {
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 0.1rem 0;
  border-bottom: 1px solid #155A97;
}

.insert-body {
  white-space: nowrap;
}

.insert-box {
  position: relative;
  width: 50%;
  display: flex;
}

.insert-row {
  display: flex;
  margin-bottom: 5px;
}

.insert-info-title {
  margin: 0.5vw 0 0.5vw 0;
  font-size: 0.8vw;
  color: #4AB0DF;
}

.data-card-body > div {
  margin-right: 2vw;
  flex-shrink: 0;
  /* display: inline-block; */
}

.data-card-item {
  width: 100% !important;
}

hr {
  width: 100%;
  height: 0.4rem;
  border: none;
}

.data-card-body>div:nth-of-type(4n) {
  margin-right: 0em !important;
  transform: translate(0, 0);
}

.data-card-body {
  padding: 0.3rem 0;
  flex-shrink: 0;
  box-sizing: content-box;
  /* display: flex; */
  /* flex-wrap: wrap; */
}

.normal-mac>div>span:last-child {
  color: #E2E4E6;
  margin-left: 0.5vw;
}

.normal-mac>div>span:first-child {
  color: #00B9E9;
}

.normal-mac>div:last-child {
  margin-right: 0;
  flex-shrink: 0;
  flex: 1;
  width: 0;
}

.normal-mac>div:first-child {
  margin-right: 3em;
  flex-shrink: 0;
}

.normal-mac {
  padding: 0.2vw 0;
  font-size: 0.8vw;
  display: flex;
}

.data-card-list {
  padding: 0 30px;
  border: 2px solid #01607E;
  flex: 1;
  width: 100%;
}

.data-card-style {
  padding: 0 30px;
  border: 2px solid #01607E;
}

.log-wb-right {
  align-items: stretch;
  justify-content: flex-end;
  flex-direction: column;
  display: inline-flex;
  position: relative;
  flex: 1;
}

.soil-mac>div {
  max-width: 100%;
}

.soil-mac>div>span:first-child {
  color: #019AC4;
  margin-right: 0.3vw;
}

.soil-mac>div>span:last-child {
  color: #DDDEDE;
}

.soil-mac {
  padding: 0.5vw 0.8vw;
  font-size: 0.8vw;
  background: #011625;
  margin-top: 1em;
  width: calc(8.6vw + 40px);
  min-width: 8.6vw;
}

.log-wb-img-farth img {
  height: auto;
  width: 8vw;
  padding: 0.5vw 0.4vw;
  min-width: 8vw;
  max-height: 14vw;
}

.log-wb-img-farth {
  background: #001624;
  flex-shrink: 0;
  flex: 1;
  box-sizing: content-box;
}

.log-wb-left {
  margin-right: 1vw;
  display: flex;
  align-items: stretch;
  flex-direction: column;
}

.log-weather-box {
  display: flex;
  grid-template-columns: auto auto;
  align-items: stretch;
  justify-content: space-between;
}
</style>
